import { render, staticRenderFns } from "./DoctorLabelDetail.vue?vue&type=template&id=179d0844&scoped=true"
import script from "./DoctorLabelDetail.vue?vue&type=script&lang=js"
export * from "./DoctorLabelDetail.vue?vue&type=script&lang=js"
import style0 from "./DoctorLabelDetail.vue?vue&type=style&index=0&id=179d0844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d0844",
  null
  
)

export default component.exports